// extracted by mini-css-extract-plugin
export default {"sectionsContainer":"MobileSearchDatalist__sectionsContainer--tfWWw"};